export default "__VITE_ASSET__BC4XOi9H__"